import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  schema?: object[];
}

export default function Seo({ title, description, schema = [] }: SeoProps) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);

    const injected: HTMLElement[] = [];
    schema.forEach((s, i) => {
      const id = `seo-jsonld-${i}`;
      let el = document.getElementById(id) as HTMLScriptElement | null;
      if (!el) {
        el = document.createElement('script');
        el.setAttribute('type', 'application/ld+json');
        el.id = id;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(s);
      injected.push(el);
    });

    return () => {
      injected.forEach((el) => el.remove());
    };
  }, [title, description, schema]);

  return null;
}